export default {
  GET_CUSTOMER_KUSPIT_CREDENTIALS_QUERY: Symbol.for('GET_CUSTOMER_KUSPIT_CREDENTIALS_QUERY'),
  CUSTOMER_KUSPIT_CREDENTIALS_REPOSITORY: Symbol.for('CUSTOMER_KUSPIT_CREDENTIALS_REPOSITORY'),
  CUSTOMER_KUSPIT_CREDENTIALS_STATE_MANAGER: Symbol.for('CUSTOMER_KUSPIT_CREDENTIALS_STATE_MANAGER'),
  SEND_CUSTOMER_KUSPIT_CREDENTIALS_COMMAND: Symbol.for('SEND_CUSTOMER_KUSPIT_CREDENTIALS_COMMAND'),
  CUSTOMER_KUSPIT_CREDENTIALS_SENDER_REPOSITORY: Symbol.for('CUSTOMER_KUSPIT_CREDENTIALS_SENDER_REPOSITORY'),
};
